export default [
  "Thai",
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "American Samoa",
  "Andorran",
  "Angolan",
  "Anguilla",
  "Antarctica",
  "Antigua And Barbuda",
  "Antilles Nether",
  "Argentinian",
  "Armenian",
  "Aruba",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bermuda",
  "Bhutanese",
  "Bolivian",
  "Bonaire, Sint Eustatius and Saba ",
  "Bosnian",
  "Botswanan",
  "Bouvet Island",
  "Brazilian",
  "British",
  "British Indian Ocean Territory ",
  "British Virgin Islands ",
  "Bruneian",
  "Bulgarian",
  "Burkinese",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Canton and Enderbury Islands ",
  "Cape Verdean",
  "Cayman Isl.",
  "Central Africa",
  "Chadian",
  "Chilean",
  "Chinese",
  "Christmas Island",
  "Cocos (Keeling) Island ",
  "Colombian",
  "Comoros",
  "Congo Dem. Rep.",
  "Congolese",
  "Cook Island",
  "Costa Rican",
  "Cote D Ivorie",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djiboutian",
  "Dominican",
  "Dominican",
  "Dutch",
  "East Timor",
  "Ecuadorean",
  "Egyptian",
  "Emirati",
  "Eq Guinea",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Falkland Island",
  "Faroe Islands",
  "Fijian",
  "Finnish",
  "French",
  "French Guiana",
  "French Polynesia",
  "French Southern Terr. ",
  "French Southern and Antartic Territories ",
  "Gabonese",
  "Gambian",
  "Gaza",
  "Georgian",
  "German",
  "Ghanaian",
  "Gibraltar",
  "Greek",
  "Greenland",
  "Grenadian",
  "Guadeloupe",
  "Guam",
  "Guatemalan",
  "Guinea Bissau",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Heard and McDonald Terr. ",
  "Held Territories",
  "Honduran",
  "Hong Kong - Chinese",
  "Hungarian",
  "Icelandic",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israel",
  "Italian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakh",
  "Kenyan",
  "Khabarovsk Krai",
  "Kiribati",
  "Kuwaiti",
  "Kyrgyzstan",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Lesotho",
  "Liberian",
  "Libyan",
  "Liechtenstein",
  "Lithuanian",
  "Luxembourg",
  "Macau",
  "Macedonian",
  "Madagascan",
  "Malawian",
  "Malaysian",
  "Maldivian",
  "Malian",
  "Maltese",
  "Marshall Island",
  "Martinique",
  "Mauritanian",
  "Mauritian",
  "Mayotte",
  "Mexican",
  "Micronesia",
  "Minor U.S. Outlying Islands ",
  "Moldovan",
  "Monacan",
  "Mongolian",
  "Montenegrin",
  "Montserrat",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nauru",
  "Nepalese",
  "New Caledonia",
  "New Zealand",
  "Nicaraguan",
  "Nigerian",
  "Nigerien",
  "Niue",
  "Norfolk Island",
  "North Korean",
  "Northern Ireland",
  "Northern Mariana Islands ",
  "Norwegian",
  "Numan",
  "Omani",
  "Other",
  "Pacific Islands, Trust Territory of The ",
  "Pakistani",
  "Palau",
  "Palestine",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Philippine",
  "Pitcairn",
  "Polish",
  "Portuguese",
  "Puerto Rico",
  "Qatari",
  "Republic of Slovenia",
  "Reunion",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Kitts and Nevis ",
  "Salvadorean",
  "Samoa",
  "San Marino",
  "Sao Tome And Principe ",
  "Saudi Arabian",
  "Senegalese",
  "Serbia and Montenegro ",
  "Serbian",
  "Seychellois",
  "Sierra Leonian",
  "Singaporean",
  "Slovak",
  "Slovenian",
  "Solomon Islands",
  "Somali",
  "South African",
  "South Georgia &amp; Sandwich Isl. ",
  "South Korean",
  "Spanish",
  "Sri Lankan",
  "St Pierre And Miquelon ",
  "St Vincent &amp; Grenadines ",
  "St. Helena",
  "St.lucia",
  "Sudanese",
  "Surinamese",
  "Svalbard and Jan Mayen ",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwan - Chinese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tokelau",
  "Tonga Island",
  "Trinidadian",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Turks And Caicos Islands ",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Us Virgin Isl.",
  "Uzbek",
  "Vanuatuan",
  "Vatican",
  "Venezuelan",
  "Vietnamese",
  "Wake Island",
  "Wallis And Futuna Islands ",
  "Western Sahara",
  "Yemen",
  "Yemeni",
  "Zambian",
  "Zaïrean",
  "Zimbabwean",
];
